<template>
  <div>
    <div class="contentBox w">
      <div class="contentStitle">Group architecture</div>
      <div class="contentTitle">架构</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
      <div class="jtjg_sTitle">下属子公司</div>
      <div class="jtjg_itemBox">
        <div class="jtjg_item" v-for="item in itemArr" :key="item.id">
          <img :src="src.zigongsi" alt="" />
          <p>{{ item.title }}</p>
          <p>{{ item.sTitle }}</p>
        </div>
      </div>
    </div>
    <div class="mobile_contentBox">
      <div class="contentStitle">Group architecture</div>
      <div class="contentTitle">公司架构</div>
      <div class="jtjg_sTitle">下属子公司</div>
      <div class="jtjg_itemBox">
        <div class="jtjg_item" v-for="item in itemArr" :key="item.id">
          <img :src="src.zigongsi" alt="" />
          <p>{{ item.title }}</p>
          <p>{{ item.sTitle }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import src from "../../../utils/assets";
export default {
  data() {
    return {
      itemArr: [
        { id: "0", title: "深圳市华普", sTitle: "劳务派遣有限公司" },
        { id: "1", title: "深圳市云久鸿", sTitle: "劳务派遣有限公司" },
        { id: "2", title: "深圳市景上鸿", sTitle: "劳务派遣有限公司" },
        { id: "3", title: "深圳市蓝聘", sTitle: "资源有限公司" },
        { id: "4", title: "深圳市云久鸿", sTitle: "人力资源有限公司" },
        { id: "5", title: "深圳市乐孚", sTitle: "技术有限公司" },
      ],
      src: src,
    };
  },
};
</script>

<style lang="less">
@media screen and (max-width: 999px) {
  .contentBox {
    display: none;
  }
  .mobile_contentBox {
    .jtjg_sTitle {
      font-size: 14px;
      font-weight: bold;
      color: #333333;
      line-height: 40px;
      letter-spacing: 10px;
      text-align: center;
    }
    .jtjg_itemBox {
      width: 350px;
      height: 260px;
      margin: 20px auto;
    }
    .jtjg_item {
      float: left;
      width: 110px;
      height: 120px;
      background: #ffffff;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
      border-radius: 10px;
      margin: 0 10px 20px 0;
      img {
        margin: 10px 0 10px;
      }
      p {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #555555;
        line-height: 20px;
      }
    }
    .jtjg_item:nth-child(3n) {
      margin-right: 0;
    }
  }
}
@media screen and (min-width: 1000px) {
  .mobile_contentBox {
    display: none;
  }

  .contentBox {
    .jtjg_sTitle {
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      line-height: 48px;
      letter-spacing: 10px;
      text-align: center;
    }
    .jtjg_itemBox {
      width: 1000px;
      margin: 20px auto;
    }
    .jtjg_item {
      float: left;
      width: 300px;
      height: 240px;
      background: #ffffff;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
      border-radius: 20px;
      margin: 0 50px 20px 0;
      img {
        margin: 60px 0 20px;
      }
      p {
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #555555;
        line-height: 36px;
      }
    }
    .jtjg_item:nth-child(3n) {
      margin-right: 0;
    }
  }
}
</style>
